module.exports = __webpack_public_path__ + "media/flags/nu-a60461b0.svg";